import * as api from './api'
import { AppDispatch } from 'src/app/store'
import * as reducers from './slice-reducers'
import { Campaign, CampaignPayload, DiscountVoucherApiPayload } from 'src/core/models'

export const getCampaings = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCampaignValue({ key: 'loading', value: true }))
    const campaigns = await api.getCampaingsAPI()
    dispatch(reducers.setCampaignValue({ key: 'data', value: campaigns }))
    dispatch(reducers.setCampaignValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.resetCampaignsState())
  }
}

export const createCampaing = (
  payload: CampaignPayload, bigList: Campaign[], userEmail: string
) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCreateCampaignValue({ key: 'loading', value: true }))
    const campaign = await api.createCampaingAPI(payload)
    const newCampaign: Campaign = { // For UX propuses
      ...campaign,
      id: (campaign as any)?.id,
      owner_user_email: userEmail,
      discount_vouchers: []
    }
    const newList = [newCampaign, ...bigList]
    dispatch(reducers.setCampaignValue({ key: 'data', value: newList }))
    dispatch(reducers.setCreateCampaignValue({ key: 'success', value: true }))
    dispatch(reducers.setCreateCampaignValue({ key: 'loading', value: false }))
  } catch (error) {
    if (error?.response?.data?.code) {
      dispatch(reducers.setCreateCampaignValue({ key: 'hasExistsError', value: true }))
    }
    dispatch(reducers.setCreateCampaignValue({ key: 'success', value: false }))
    dispatch(reducers.setCreateCampaignValue({ key: 'loading', value: false }))
  }
}

export const createDiscountVoucher = (payload: DiscountVoucherApiPayload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCreateDiscountVoucheralue({ key: 'loading', value: true }))
    await api.createDiscountVOucherAPI(payload)
    dispatch(reducers.setCreateDiscountVoucheralue({ key: 'success', value: true }))
    dispatch(reducers.setCreateDiscountVoucheralue({ key: 'loading', value: false }))
  } catch (error) {
    const ownerError: string[] = error?.response?.data?.non_field_errors
    if (ownerError?.length > 0) {
      dispatch(reducers.setCreateDiscountVoucheralue({ key: 'hasOnwerError', value: true }))
    }
    dispatch(reducers.setCreateDiscountVoucheralue({ key: 'success', value: false }))
    dispatch(reducers.setCreateDiscountVoucheralue({ key: 'loading', value: false }))
  }
}
